/* eslint-disable no-restricted-globals */
import axios from 'axios';
import https from 'https';

const axiosPrivate = axios.create({
  baseURL: `/sso`,
  httpsAgent: new https.Agent({
    rejectUnauthorized: true,
  }),
});

export default axiosPrivate;
